import { SubGroupChips } from '@/components/league-navigator/components/SubGroupChips';

import { useSelectedNavigationEntry } from '../../hooks/use-selected-navigation-entry';

export const SubGroupChipsRow = () => {
    const { selectedTile, subGroups, selectedSubGroupId, setSelectedSubGroup } = useSelectedNavigationEntry();

    if (!selectedSubGroupId) {
        return null;
    }

    return (
        <SubGroupChips
            rowKey={selectedTile}
            items={subGroups}
            selectedId={selectedSubGroupId}
            onSelect={setSelectedSubGroup}
        />
    );
};
